import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=069cd4f9&scoped=true"
import script from "./Historial.vue?vue&type=script&lang=js"
export * from "./Historial.vue?vue&type=script&lang=js"
import style0 from "./Historial.vue?vue&type=style&index=0&id=069cd4f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069cd4f9",
  null
  
)

export default component.exports